import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './Matter.css';
import PageTitle from '../Layout/components/PageTitle';
import { Button, Paper, Table, TableHead, TableRow, TableCell, TableBody, Dialog, Breadcrumbs, Link, Typography, TableFooter, TablePagination } from '@material-ui/core';
import AddMatter from './components/AddMatter';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { roleStr, defaultPageSize, ADD, EDIT, VIEW } from '../../common/common'
import { timeFormat } from '../../common/utils'
import instance from '../../request/http';
import { BASE_URL } from '../../store/config';
import Toast from '../Layout/components/Toast';
import AlertDialog from '../Layout/components/AlertDialog'

class Matter extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            matters: [],
            caseNumber: "",
            open: false,
            dialogState: ADD,
            dialogTitle: "",
            crtMatterObj: null,
            case_id: localStorage.getItem('case_id'),

            page_index: 1,
            page_size: defaultPageSize,
            total_items: 0,

            showToast: false,
            toastMsg: "",
            toastState: "",
            showAlert: false,
        }
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleAddMatter = this.handleAddMatter.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
    }
    render() {
        const {
            open,
            matters,
            caseNumber,
            case_id,
            page_index,
            page_size,
            total_items,
            showToast,
            toastMsg,
            toastState,
            showAlert,
            dialogTitle,
            dialogState,
            crtMatterObj,
        } = this.state;
        // const delBtn = (row) => {
        //     if (roleName === ADMIN) {
        //         return <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
        //     }
        // }
        return (
            <Root>
                <div className="head h">
                    <div className="v">
                        <PageTitle subtitle="MANAGEMENT"></PageTitle>
                        <Breadcrumbs separator="›" aria-label="breadcrumb">
                            <Link className="title" href="/main/case">All Cases</Link>
                            <Typography className="crtTitle">{caseNumber}</Typography>
                        </Breadcrumbs>
                    </div>
                    <div className="f h h-r">
                        <Button variant="contained" color="primary" onClick={this.handleAddMatter}>CREATE MATTER</Button>
                    </div>
                    <Dialog maxWidth={false} open={open}>
                        <AddMatter
                            handleCreate={this.handleCreate}
                            handleCancel={this.handleCancel}
                            title={dialogTitle}
                            data={crtMatterObj}
                            caseId={case_id}
                            caseNumber={caseNumber}
                            state={dialogState}
                        ></AddMatter>
                    </Dialog>
                </div>
                <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Matter Number</TableCell>
                                <TableCell>Matter Name</TableCell>
                                <TableCell>Client</TableCell>
                                <TableCell>Creator</TableCell>
                                <TableCell>Originating Attorney</TableCell>
                                <TableCell>Team</TableCell>
                                <TableCell>Office</TableCell>
                                <TableCell>Modified Time</TableCell>
                                <TableCell>Create Time</TableCell>
                                <TableCell>Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {matters.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell component="th" scope="row">
                                        {row.number}
                                    </TableCell>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{this.clientName(row.case)}</TableCell>
                                    <TableCell>{this.hanlderInfo(row, "username")}</TableCell>
                                    <TableCell>{this.hanlderInfo(row, "name")}</TableCell>
                                    <TableCell>{this.hanlderInfo(row, "team")}</TableCell>
                                    <TableCell>{this.hanlderInfo(row, "office")}</TableCell>
                                    <TableCell>{timeFormat(row.update_time)}</TableCell>
                                    <TableCell>{timeFormat(row.create_time)}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
                                            {/* {delBtn(row)} */}
                                            <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {matters.length === 0 && (
                                <TableRow style={{ height: 300 }}>
                                    <TableCell colSpan={12} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75]}
                                    colSpan={12}
                                    count={total_items}
                                    page={matters.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: { 'arialabel': 'Rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this matter?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }
    componentDidMount() {
        const caseNumber = localStorage.getItem('case_num');
        const case_id = localStorage.getItem('case_id');
        this.setState({
            caseNumber,
            case_id
        }, () => {
            this.initData();
        })
    }
    initData() {
        this.getMatters();
    }
    clientName(caseObj) {
        if (caseObj) {
            const client = caseObj.client;
            if (client.individual) {
                return client.individual.first_name + " " + client.individual.last_name;
            } else if (client.corporation) {
                return client.corporation.name;
            } else {
                return "--";
            }
        } else {
            return "--";
        }
    }
    handleAddMatter() {
        this.openDialog("CREATE MATTER", ADD);
    }
    handleView(e, obj) {
        this.setState(() => ({
            crtMatterObj: obj
        }))
        this.openDialog("MATTER INFO", VIEW);
    }
    handleEdit(e, obj) {
        this.setState(() => ({
            crtMatterObj: obj
        }))
        console.log(obj)
        this.openDialog("EDIT MATTER INFO", EDIT);
    }
    handleDel(e, obj) {
        this.setState(() => ({
            crtMatterObj: obj,
            showAlert: true
        }))
    }
    //关闭dialog
    handleCloseDialog() {
        this.closeDialog();
    }
    handleCreate(obj) {
        const { dialogState, crtMatterObj, case_id } = this.state;
        if (dialogState === ADD) {
            this.createMatters(case_id, obj);
        } else if (dialogState === EDIT) {
            let matter_id = crtMatterObj.id;
            this.updateMatters(case_id, matter_id, obj);
        }
    }
    //取消dialog
    handleCancel() {
        this.closeDialog();
    }
    handleChangePage(e, newPage) {
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getMatters();
        })
    }
    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getMatters();
        });
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleAlertYes() {
        const { case_id, crtMatterObj } = this.state;
        let matter_id = crtMatterObj.id;
        this.delMatters(case_id, matter_id);
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            crtMatterObj: null,
        }));
    }
    openDialog(title, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    hanlderInfo(row, type) {
        if (!row.handler) return "";
        if (row.handler.length <= 0) return "";
        let attorneyObj = {};
        for (const obj of row.handler) {
            if (obj.is_origin_attorney) {
                attorneyObj = obj;
            }
        }
        if (type === "team") {
            return attorneyObj.team ? attorneyObj.team.name : "";
        } else if (type === "office") {
            return attorneyObj.team ? attorneyObj.team.dept_info.office : "";
        } else if (type === "name") {
            return attorneyObj.user ? attorneyObj.user.first_name + " " + attorneyObj.user.last_name : "";
        } else if (type === "username") {
            return attorneyObj.user ? attorneyObj.user.username : "";
        }
    }
    membersNum(arr) {
        if (arr) {
            return arr.length;
        }
    }
    getMatters() {
        const { case_id, page_index, page_size, caseNumber } = this.state;
        const params = {
            case_number: caseNumber,
            page_index,
            page_size
        }
        this.getMatterList(case_id, params);
    }
    editHandlers(matter_id, membersObj, callback) {
        const addMembers = membersObj.addMembers;
        const delMembers = membersObj.delMembers;
        const addIndex = addMembers.length;
        const delIndex = delMembers.length;
        if (addIndex <= 0 && delIndex <= 0) {
            callback();
        } else if (addIndex > 0 && delIndex > 0) {
            this.addMembers(matter_id, addMembers, () => {
                this.delMembers(matter_id, delMembers, () => {
                    callback();
                });
            });
        } else if (addIndex > 0) {
            this.addMembers(matter_id, addMembers, () => {
                callback();
            });
        } else if (delIndex > 0) {
            this.delMembers(matter_id, delMembers, () => {
                callback();
            });
        }
    }
    //-----------request-------------
    getMatterList(case_id, params) {
        console.log(case_id, params)
        instance.get(BASE_URL + roleStr() + '/matters', { params }).then((res) => {
            const value = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(value)
            let matters = [];
            if (value) {
                matters = value;
            }
            this.setState(() => ({
                matters,
                page_size,
                total_items
            }))
        })
    }
    createMatters(case_id, obj) {
        let params = {
            case_id: parseInt(case_id),
            number: obj.number,
            name: obj.name,
            note: obj.note,
            handlers: obj.handlers.addMembers
        }
        instance.post(BASE_URL + "" + roleStr() + "/matters", params).then((res) => {
            this.showToast("Added successfully", "success");
            this.getMatters();
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    updateMatters(case_id, matter_id, obj) {
        console.log(obj.number)
        let params = {
            case_id: parseInt(case_id),
            number: obj.number,
            name: obj.name,
            note: obj.note,
        }
        instance.put(BASE_URL + "" + roleStr() + "/matters/" + matter_id, params).then((res) => {
            this.editHandlers(matter_id, obj.handlers, () => {
                this.showToast("Successfully modified", "success");
                this.getMatters();
                this.closeDialog();
            });
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delMatters(case_id, matter_id) {
        const role = roleStr() === "admin" ? "admin" : "common";
        instance.delete(BASE_URL + "" + role + "/matters/" + matter_id).then((res) => {
            console.log("del", res)
            this.showToast("Successfully deleted", "success");
            this.getMatters();
        }).catch((err) => {
            const errorCode = err.response.data.error;
            if (errorCode === 3000) {
                this.showToast("Failed to delete, the matter has been used", "error");
            }
        })
    }
    addMembers(matter_id, handlers, callback) {
        let params = {
            handlers
        }
        instance.post(BASE_URL + roleStr() + '/matters/' + matter_id + '/handlers', params).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delMembers(matter_id, handlers, callback) {
        let params = {
            handlers
        }
        instance.delete(BASE_URL + roleStr() + '/matters/' + matter_id + '/handlers', { data: params }).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}


export default withRouter(Matter);